// /home/cockskiz/new.greatlysocial.com/frontend/src/pages/dashboard/post/pinterest/PinterestBoardsModal.js

import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';

/**
 * PinterestBoardsModal
 *
 * Props:
 *   show               - boolean
 *   onHide             - function
 *   pinterestId        - the connected Pinterest account ID
 *   onBoardSelected    - callback(selectedBoardIdsArray)
 */
export default function PinterestBoardsModal({ show, onHide, pinterestId, onBoardSelected }) {
  const [boards, setBoards] = useState([]);
  const [loading, setLoading] = useState(false);
  // For multiple boards, we store an array of selected IDs
  const [selectedBoardIds, setSelectedBoardIds] = useState([]);

  useEffect(() => {
    if (show && pinterestId) {
      fetchBoards();
    }
  }, [show, pinterestId]);

  async function fetchBoards() {
    try {
      setLoading(true);
      setBoards([]);
      setSelectedBoardIds([]); // reset any prior selection

      // Use /api/posting/pinterest/list?pinterestId=...
      const url = `/api/posting/pinterest/list?pinterestId=${pinterestId}`;
      const res = await fetch(url, { credentials: 'include' });
      if (!res.ok) {
        console.error(`Failed to fetch boards. Status = ${res.status}`);
        return;
      }

      const data = await res.json();
      if (Array.isArray(data)) {
        setBoards(data); // e.g. [ { board_id, board_name, board_description }, ... ]
      } else {
        console.warn('Boards response is not an array:', data);
      }
    } catch (err) {
      console.error('Error fetching boards:', err);
    } finally {
      setLoading(false);
    }
  }

  function handleToggleBoard(boardId) {
    setSelectedBoardIds((prev) => {
      if (prev.includes(boardId)) {
        // If already selected, remove it
        return prev.filter((id) => id !== boardId);
      } else {
        // Otherwise, add it
        return [...prev, boardId];
      }
    });
  }

  function handleConfirm() {
    if (selectedBoardIds.length === 0) {
      alert('Please select at least one board!');
      return;
    }
    // Send the array of IDs back to parent
    onBoardSelected(selectedBoardIds);
  }

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Select One or More Pinterest Boards</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <p>Loading boards...</p>
        ) : boards.length === 0 ? (
          <p>No boards found.</p>
        ) : (
          <div>
            {boards.map((b) => (
              <div key={b.board_id} className="form-check mb-2">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id={`board-check-${b.board_id}`}
                  checked={selectedBoardIds.includes(b.board_id)}
                  onChange={() => handleToggleBoard(b.board_id)}
                />
                <label
                  className="form-check-label"
                  htmlFor={`board-check-${b.board_id}`}
                >
                  {b.board_name || 'Untitled Board'}
                </label>
              </div>
            ))}
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleConfirm}>
          Confirm
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
